import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { ControlledTextField } from 'components/shared';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import FormSubSection from '../../FormSubSection';

const HoursBalanceSection = () => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.hours_balance'
  });

  return (
    <MultiStepForm.Section title={t('title')}>
      <FormSubSection title={t('deviation')}>
        <Grid item xs={12}>
          <ControlledTextField
            control={control}
            label={t('employed')}
            variant="outlined"
            type="number"
            name="finEBalHrsPrc"
          />
        </Grid>
        <Grid item xs={12}>
          <ControlledTextField
            control={control}
            label={t('leave')}
            variant="outlined"
            type="number"
            name="finEBalLvPrc"
          />
        </Grid>
      </FormSubSection>
    </MultiStepForm.Section>
  );
};

export default HoursBalanceSection;
